import configIR from './json/ir/config.json'

export const getConfig = () => configIR
